import React from 'react';
import AdminLayout from '../../components/AdminLayout';
import UserDetail from '../../components/UserDetail';

const ProfilePage = () => {
  return (
    <AdminLayout>
      <UserDetail />
    </AdminLayout>
  );
};

export default ProfilePage;
